__turbopack_context__.v({
  "close-button": "Dialog-module-scss-module__gL-AAq__close-button",
  "dialog-content": "Dialog-module-scss-module__gL-AAq__dialog-content",
  "dialog-footer": "Dialog-module-scss-module__gL-AAq__dialog-footer",
  "dialog-overlay": "Dialog-module-scss-module__gL-AAq__dialog-overlay",
});
